import { render, staticRenderFns } from "./replay.vue?vue&type=template&id=bfa27e48&scoped=true"
import script from "./replay.vue?vue&type=script&lang=js"
export * from "./replay.vue?vue&type=script&lang=js"
import style0 from "./replay.vue?vue&type=style&index=0&id=bfa27e48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfa27e48",
  null
  
)

export default component.exports